import { datadogRum } from "@datadog/browser-rum";
import { Inject, Injectable } from "@webmotors/ioc";
import { LOGGER, type Logger } from "../logger";
import { DatadogConfigDTO } from "./dtos";
import { window } from "@packages/global";

@Injectable("DatadogService")
export class DatadogService {
  private logger: Logger;
  private isInitialized = false;

  constructor(@Inject(LOGGER) private loggerFactory: Logger) {
    this.logger = this.loggerFactory.create("DatadogService");
  }

  initializeDatadog(config: DatadogConfigDTO): void {
    if (this.isInitialized) {
      return;
    }

    const datadogConfig = new DatadogConfigDTO(config);

    const filteredParams = Object.fromEntries(
      Object.entries(datadogConfig).filter(([_, value]) => value !== undefined)
    ) as DatadogConfigDTO;

    datadogRum.init({
      ...filteredParams,
    });

    this.isInitialized = true;
    window.DD_RUM = datadogRum
    this.logger.log("[Initialize] Datadog initialized successfully.");
  }
}
